import { Component,  Input,  OnInit } from '@angular/core';

@Component({
  selector: 'gradient-button',
  templateUrl: './gradient-button.component.html',
  styleUrls: ['./gradient-button.component.css']
})
export class GradientButtonComponent implements OnInit {


@Input() g1: string 
@Input() g2: string 
@Input() g3: string 
constructor() { }

  ngOnInit(): void {
    if(!this.g1 && !this.g2 && !this.g3){

      this.g1 = "#FF9800"
      this.g2 = "#FF7b4d"
      this.g3 = "#FF4520"
     }
  }

}
